<template>
  <div class="chart-card">
    <slot />
  </div>
</template>

<style lang="less" scoped>
.chart-card {
  position: relative;
  background: @white;
  border-radius: 8px;
  border: 1px solid @stroke-default;
}
</style>
